<div class="scope-row items-center">
  <div
    class="scope-row-content flex items-center"
    (click)="selectComponent()">
    <div
      class="column level-{{ level }} flex items-center"
      [ngClass]="config?.componentMainColumnClass">
      <mat-icon
        class="material-symbols-rounded arrow orange"
        [ngClass]="{ active: scopeElementsService.componentStates.selected[component.id] }">
        expand_more
      </mat-icon>
      <div class="flex flex-row items-center pl-1">
        <span
          class="component-risk-indicator"
          [ngClass]="getRiskIndicatorClass()"></span>
        <div class="flex-col">
          <commentable
            style="--line-clamp: 1"
            [c-root-entity]="deliverable"
            [c-entity]="component"
            c-key="name"
            c-type="component">
            {{ component.name && component.name.length > 0 ? component.name : component.source?.name }}
          </commentable>
          <span class="source-name">{{ component.source?.name }}</span>
        </div>
      </div>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="quantityModifier"
        c-type="component">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'quantityModifier',
              valueFn: formatModifier,
              defaultValue: formatModifier(component.quantityModifier),
            }
          " />
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.QUANTITY?.selected">
      <scope-ui-counter
        *ngIf="updatedConfig?.isDeliverableEditable"
        [initialValue]="getFieldToDisplay('quantity')"
        [min]="0"
        (onUpdateValue)="updateComponent({ quantity: $event })" />
      <span *ngIf="!updatedConfig?.isDeliverableEditable">
        <commentable
          [c-root-entity]="deliverable"
          [c-entity]="component"
          c-key="quantity"
          c-type="component"
          [c-action]="overrideQuantity()"
          c-action-text="Change Quantity"
          [c-action-privilege]="
            config?.scopeVersion.identity.isTemplate
              ? Privilege.SCOPE_TEMPLATE__EDIT
              : Privilege.SCOPE_REVIEW__EDIT_COMPONENT_QUANTITY
          ">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'quantity',
                defaultValue: component.quantity,
              }
            " />
        </commentable>
      </span>
    </div>
    <div
      class="column one--column"
      [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
      <span>{{ component.startDate || deliverable.startDate | dateFormat: 'shortDate' }}</span>
    </div>
    <div
      class="column one--column"
      [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
      <span>{{ component.endDate || deliverable.endDate | dateFormat: 'shortDate' }}</span>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.MARK_UP?.selected"
      [has-privilege]="Privilege.SCOPE_MARKUP__VIEW && Privilege.SCOPE_MARGIN__VIEW">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component">
        <span
          class="tag-label"
          *ngIf="component.hasCostPlus() && currentUser.company.hasApplicationSetting(ApplicationSetting.COST_PLUS)">
          Cost Plus
        </span>
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'markup',
              valueFn: formatPercentage,
              defaultValue: getMarkup(),
            }
          " />
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline"
      [has-setting]="ApplicationSetting.COMPONENT_SIZES__ENABLE">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="complexity"
        c-type="component">
        {{ component.complexity }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="scopeMarkHours"
        c-type="component">
        {{ component.scopeMarkTotalHours | formatHours }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="scopeMarkSellingPrice"
        c-type="component">
        {{
          component.scopeMarkTotalSellingPrice
            ? (component.scopeMarkTotalSellingPrice.amount | convertCurrency: config?.currency)
            : DEFAULT_PLACEHOLDER
        }}
      </commentable>
    </div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_HOURS?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="rateCardHours"
        c-type="component">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'rateCardTotalHours',
              valueFn: formatHours,
              defaultValue: component.getTotalRateCardHours(),
            }
          " />
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.UNIT_PRICE?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="agencyUnitSellingPrice"
        c-type="component"
        [has-privilege]="Privilege.SCOPE__VIEW_RATES"
        [has-privilege-mask]="'--'">
        {{
          component.getUnitSellingPrice()?.amount != null
            ? (component.getUnitSellingPrice().amount | convertCurrency: config?.currency)
            : '--'
        }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="component"
        c-key="priceModifier"
        c-type="component">
        <ng-container
          *ngTemplateOutlet="
            fieldDifference;
            context: {
              fieldName: 'priceModifier',
              valueFn: formatModifier,
              defaultValue: formatModifier(component.priceModifier),
            }
          " />
      </commentable>
    </div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_PRICE?.selected">
      <div
        class="flex flex-col items-center component-agency-price"
        [has-privilege]="Privilege.SCOPE__VIEW_RATES">
        <span
          *ngIf="component?.fixedPricing"
          class="fixed-price-label">
          fixed fee
        </span>

        <ng-template #agencyPrice>
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'agencyPrice',
                valueFn: formatPrice,
                defaultValue: component.getComponentPrice(config?.currency)?.amount,
              }
            " />
        </ng-template>

        <commentable
          *ngIf="!isAgencyPriceEditable"
          [c-root-entity]="deliverable"
          [c-entity]="component"
          c-key="agencySellingPrice"
          c-type="component">
          <ng-container [ngTemplateOutlet]="agencyPrice"></ng-container>
        </commentable>

        <div
          *ngIf="isAgencyPriceEditable"
          class="flex items-center justify-center scope-editable-field">
          <ng-container *ngIf="!isEditAgencyPrice">
            <ng-container [ngTemplateOutlet]="agencyPrice"></ng-container>

            <mat-icon
              *ngIf="component?.fixedPricing"
              class="material-symbols-rounded fill orange text-sm"
              (click)="editAgencyPrice($event)">
              mode_edit
            </mat-icon>
          </ng-container>

          <scope-ui-input
            *ngIf="isEditAgencyPrice"
            type="text"
            [parseNumber]="true"
            [isCurrency]="true"
            [autofocus]="true"
            [noArrows]="true"
            [maximumLength]="17"
            [currency]="component.fixedCost?.currency"
            [initialValue]="component.fixedCost?.amount"
            [control]="agencyPriceControl"
            (click)="preventDefault($event)"
            (onInputBlurChange)="updateAgencyPrice($event)" />
        </div>
      </div>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.showActionsColumn">
      <button
        *ngIf="showToggleMenu()"
        mat-mini-fab
        class="toggle-button float-right ml-1"
        [ngClass]="config?.isTimeline ? 'mr-1' : 'mr-2'"
        [matMenuTriggerFor]="deliverableMenu"
        (click)="$event.stopPropagation()">
        <mat-icon class="material-symbols-rounded">more_horiz</mat-icon>
      </button>
      <mat-menu
        #deliverableMenu="matMenu"
        backdropClass="customize">
        <ng-container *ngFor="let option of componentMenuOptions">
          <button
            *ngIf="!(option.isHidden?.(component) || option.isDetached?.(component))"
            mat-menu-item
            (click)="option.callback(component)">
            <mat-icon class="material-symbols-rounded orange">{{ option.icon() }}</mat-icon>
            <span class="library-option-name">{{ option.name() | langf }}</span>
          </button>
        </ng-container>
      </mat-menu>

      <ng-container *ngFor="let option of componentMenuOptions">
        <button
          *ngIf="!option.isHidden?.(component) && option.isDetached?.(component)"
          class="toggle-button float-right ml-1"
          mat-mini-fab
          (click)="option.callback(component)">
          <mat-icon class="material-symbols-rounded fill">mode_edit</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>

  <div
    *ngIf="!config?.isTimeline"
    class="flex flex-col w-full scope-description-container description-row">
    <description-editor
      class="level-{{ level }} description-editor"
      [(visible)]="scopeElementsService.componentStates.description[deliverable.id]"
      [model]="component"
      [editable]="updatedConfig?.isEditable"
      [extraDescription]="true"
      [(disableDragging)]="scopeElementsService.disableDragging"
      (onSaveDescription)="updateComponent({ description: $event })"
      (onSaveExtraDescription)="saveComponentExtraDescription($event)"
      (onSaveNote)="updateComponent({ internalNote: $event })">
    </description-editor>
  </div>

  <ng-container *ngIf="scopeElementsService.componentStates.selected[component.id]">
    <scope-departments
      [component]="component"
      [config]="updatedConfig"
      [level]="level + 1"
      [departments]="component.departments"
      (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
      (onUpdateRole)="onUpdateRole.emit($event)">
    </scope-departments>

    <scope-third-party-costs
      *ngIf="component.thirdPartyCosts?.length && !config?.isTimeline"
      class="w-full"
      [config]="updatedConfig"
      [parent]="component"
      [level]="level + 1"
      [columns]="getTpcColumns()"
      (onUpdateTpc)="updateComponentTpc($event)"
      (onReorderTpcs)="reorderComponentTpcs($event)">
    </scope-third-party-costs>

    <scope-fees
      *ngIf="component.feeItems?.length && !config?.isTimeline"
      [has-setting]="ApplicationSetting.COMPONENT__ENABLE_FEES"
      [parent]="component"
      [config]="updatedConfig"
      [columns]="scopeElementsService.componentFeeColumns"
      [level]="level + 1"
      [feeMenuOptions]="feeMenuOptions"
      [tableStates]="scopeElementsService.componentFeeStates"
      (onUpdateFeeItem)="onUpdateComponentFee.emit({ feeItem: $event, deliverable, component })">
    </scope-fees>

    <div
      *ngIf="!config?.isTimeline"
      class="scope-row-header flex items-center scope-row-content rounded-b">
      <div class="column level-{{ level }} {{ config?.componentMainColumnClass }}">
        <span>Component total</span>
      </div>
      <div
        class="column one--column"
        [hidden]="!config?.scopeVersion.isScopeByScenario()"></div>
      <div class="column one--column"></div>
      <div class="column one--column"></div>
      <div class="column one--column"></div>
      <div
        class="column one--column"
        [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected"></div>
      <div
        class="column one--column"
        [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected"></div>
      <div
        class="column one--column"
        [hidden]="!config?.userColumns.AGENCY_HOURS?.selected">
        <commentable
          [c-root-entity]="deliverable"
          [c-entity]="component"
          [c-key]="'totalComponentUnitRateCardHours'"
          [c-type]="'component'">
          <span
            [has-setting]="ApplicationSetting.SCOPE__AGENCY_HOURS"
            [has-setting-disabled-mask]="'--'">
            <ng-container
              *ngTemplateOutlet="
                fieldDifference;
                context: {
                  fieldName: 'rateCardTotalHours',
                  valueFn: formatHours,
                  defaultValue: component.getTotalRateCardHours(),
                }
              " />
          </span>
        </commentable>
      </div>
      <div
        class="column one--column"
        [hidden]="!config?.scopeVersion.isScopeByScenario()"></div>
      <div
        class="column one--column"
        [hidden]="!config?.userColumns.AGENCY_PRICE?.selected">
        <commentable
          [c-root-entity]="deliverable"
          [c-entity]="component"
          [c-key]="'totalComponentUnitAgencySellingPrice'"
          [c-type]="'component'">
          <span
            [has-privilege]="Privilege.SCOPE__VIEW_RATES"
            [has-privilege-mask]="'--'">
            <ng-container
              *ngTemplateOutlet="
                fieldDifference;
                context: {
                  fieldName: 'agencyPrice',
                  valueFn: formatPrice,
                  defaultValue: component.getTotalSellingPrice()?.amount,
                }
              " />
          </span>
        </commentable>
      </div>
      <div class="column one--column"></div>
    </div>
  </ng-container>
</div>

<ng-template
  #fieldDifference
  let-fieldName="fieldName"
  let-valueFn="valueFn"
  let-defaultValue="defaultValue">
  <scope-field-difference
    [isChangeRequest]="config?.isChangeRequest"
    [fieldName]="fieldName"
    [defaultValue]="defaultValue"
    [changes]="component.changes"
    [getFieldToDisplay]="getFieldToDisplay"
    [showDiff]="showDiff"
    [valueFn]="valueFn"
    [showNetDelta]="showNetChanges(fieldName)"
    [netDeltaValue]="getNetChanges(fieldName, defaultValue)" />
</ng-template>
